import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegExp } from 'src/app/core/config/regex';
import { Context } from 'src/app/shared/models/context';
import { Due, Message, Particular, Payment, PaymentParticular, ProvidentFund, Salary, SalaryParticular } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
@Component({
  selector: 'app-due-check',
  templateUrl: './due-check.component.html',
  styleUrls: ['./due-check.component.scss']
})
export class DueCheckComponent implements OnInit {
  @Input() date: string;
  @Input() sid: number;
  @Input() context: Context;
  @Input() salaries: Salary[] = [];
  @Input() payment: Payment;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  public dueForm: FormGroup;
  public PaymentParticularForm: FormGroup;
  public particulars: Particular[] = [];
  public empcheck: boolean = false;
  public isShown: boolean = false;
  public salaryId: number;
  public submitted: boolean = false;
  public payments: Map<string, PaymentParticular[]> = new Map();
  public submittedParticular: boolean = false;
  private modified: boolean = false;
  public frequency: string;
  public fromDate: string;
  public toDate: string;
  public providentFundName: string;
  public basicSalary: number;
  public active: boolean;
  public paymentId: number;
  public providentFund: number; // Add this property


  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private commonService: CommonService,
    private employeeService: EmployeeService,
    private toaster: ToastrService,
    private datePipe: DatePipe
  ) {
  }

  ngOnInit(): void {
    this.setPayments([]);
    this.setDue();
    if (this.sid) {
      this.employeeService.getSalary(this.sid).subscribe((salary) => {
        this.frequency = salary.frequency;
        this.fromDate = salary.fromDate = this.datePipe.transform(salary.fromDate, 'yyyy-MM-dd');
        this.toDate = salary.toDate = this.datePipe.transform(salary.toDate, 'yyyy-MM-dd');
        this.providentFundName = salary.providentFundName;
        this.basicSalary = salary.basicSalary;
        this.paymentId = salary.paymentId;
        this.active = salary.active;
        this.providentFund = salary.providentFund; // <-- ADD THIS!

      });
      this.employeeService.getSalaryParticulars(this.sid, false).subscribe(salaryParticular => {
        this.setPayments(salaryParticular);

      });
    }
  }

  get PaymentParticulars(): FormArray {
    return this.PaymentParticularForm.get("paymentParticulars") as FormArray;
  }

  private setPayments(salaryParticulars: SalaryParticular[]) {
    this.PaymentParticularForm = this.fb.group({
      paymentParticulars: this.fb.array([])
    });
    if (salaryParticulars && salaryParticulars.length > 0) {
      salaryParticulars.forEach((particular) => this.createPayment(particular));
    }
  }

  public setDue(due?: Due): void {
    if (!due) {
      due = {
        id: null,
        paymentId: null,
        remarks: null,
        referenceId: null,
        date: null,
        salaryDate: this.date,
        paymentMode: null,
        status: 'DUE',
        salaryId: this.sid,
        accountId: null,
        paymentParticulars: [],
      } as Due;
    }
    this.dueForm = this.fb.group({
      id: this.fb.control(due?.id),
      paymentId: this.fb.control(due.paymentId || this.paymentId, []),
      remarks: this.fb.control(due.remarks, []),
      referenceId: this.fb.control(due.referenceId, []),
      date: this.fb.control(due.date, []),
      salaryDate: this.fb.control(due.salaryDate, []),
      paymentMode: this.fb.control(due.paymentMode, []),
      status: this.fb.control(due.status, []),
      salaryId: this.fb.control(due.salaryId, []),
      accountId: this.fb.control(due.accountId, []),
      paymentParticulars: this.fb.array([]),
    });

    this.dueForm.valueChanges.subscribe(value => this.modified = true);
  }

  private createPayment(salaryParticular?: SalaryParticular) {
    this.PaymentParticulars.push(this.fb.group({
      id: this.fb.control(null),
      value: this.fb.control(salaryParticular?.value || '', [Validators.required, Validators.min(0)]),
      salaryParticularId: this.fb.control(salaryParticular?.id || null, []),
      salaryParticularName: this.fb.control(salaryParticular.particularName),
      earnings: this.fb.control(salaryParticular.earnings), // <-- ADD THIS LINE
      paymentId: this.fb.control(this.paymentId, []),
    }));
  }

  public saveDue(inProgress: any) {
    this.submitted = true;
    const due = this.dueForm.value as Due;
    let payments: PaymentParticular[] = [];
    this.PaymentParticulars.controls.forEach(control => {
      const formValue = control.value;
      if (formValue) {
        payments.push({
          id: formValue.id || null,
          value: formValue.value,
          salaryParticularId: formValue.salaryParticularId,
          salaryParticularName: formValue.salaryParticularName,
          paymentId: formValue.paymentId || this.paymentId,
        });
      }
    });
    due.paymentParticulars = payments;
    if (this.dueForm.valid) {
      inProgress.value = true;
      this.employeeService.createDue(due).subscribe({
        next: (response: Message) => {
          inProgress.value = false;
          if (!response.failed) {
            this.activeModal.close(true);
            this.commonService.setToastr(200, 'Due successfully updated.');
          } else {
            this.commonService.setToastr(500, 'Failed to update due.');
          }
        },
        error: (error: HttpErrorResponse) => {
          inProgress.value = false;
          this.commonService.setToastr(500, error?.error?.name || 'An unexpected error occurred.');
        },
      });
    }
  }

  get totalAmount() {
    let totalParticulars = this.PaymentParticulars.controls.reduce((sum, control) => {
      const value = control.get('value')?.value || 0;
      const earnings = control.get('earnings')?.value; 
  
      if (earnings === false) {
        return sum - value; 
      }
      return sum + value;
    }, 0);
  
    return (this.basicSalary) + totalParticulars - (this.providentFund || 0);
  }
  
}